// ============================================================
//  TEAMS — Firestore-Collection "teams"
//  Ersetzt Sanity fetchTeams(). Felder wie im Sanity-Schema,
//  "bild" ist jetzt eine direkte Storage-URL (string) statt Referenz.
// ============================================================
import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const COLLECTION = "teams";

export async function fetchTeams() {
  const q = query(collection(db, COLLECTION), orderBy("sortierung", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchTeam(id) {
  const snap = await getDoc(doc(db, COLLECTION, id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function createTeam(daten) {
  const ref = await addDoc(collection(db, COLLECTION), daten);
  return ref.id;
}

export async function updateTeam(id, daten) {
  await updateDoc(doc(db, COLLECTION, id), daten);
}

export async function deleteTeam(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}
